import { useParams } from 'react-router-dom';
import RegistryModule from '../components/RegistryModule';

export default function ModuleEditPage() {
  const { platform, moduleName, id } = useParams() as { platform: string, moduleName: string, id: string };

  return (
    <RegistryModule platform={platform} moduleName={moduleName} id={id} />
  );
}